import { useEffect } from 'react';
import { CheckboxElement, useFormContext } from 'react-hook-form-mui';

import { useCurrentProduct } from 'api/products';

export function CanSignFiles({ hardwareBindingName, name, disabled }) {
    const { data: currentProduct } = useCurrentProduct();

    const { watch, resetField } = useFormContext();

    const hardwareBindingId = watch(hardwareBindingName);
    const showCanSignFiles =
        (currentProduct?.can_sign_files &&
            currentProduct?.hardwareBindings?.find(binding => binding.id === hardwareBindingId)?.licenseGenerator
                ?.can_sign_files) ??
        false;

    useEffect(() => {
        if (!showCanSignFiles) {
            resetField(name);
        }
    }, [showCanSignFiles, resetField, name]);
    if (!showCanSignFiles) return null;
    return <CheckboxElement name={name} label="License can sign files" disabled={disabled} />;
}
